<template>
  <DonutChart
      :title="'En İyi Satış'"
      :description="'Ürün bazlı çok satan ürünler'"
      :donutChartOptions="giroAnalysisDataChartOptions"
      :loading="giroAnalysisDataLoading"
  >
    <template>
      <v-select
          v-model="giroAnalysisStockCodeFilterValue"
          :items="[
                      {value: 1, text: 'Grup Kodu'},
                      {value: 2, text: 'KOD 1'},
                      {value: 3, text: 'KOD 2'},
                      {value: 4, text: 'KOD 3'},
                      {value: 5, text: 'KOD 4'},
                      {value: 6, text: 'KOD 5'}

                    ]"
          style="width:100px;margin: 0 3px"
          item-text="text"
          item-value="value"
          hide-details
          dense
          solo
          @change="_fetchGiroAnalysisReport"
      >
      </v-select>
      <v-select
          v-model="giroAnalysisTimePeriodFilterValue"
          :items="[
              {value: 5, text: 'Tarih Aralığı'},
              {value: 4, text: 'Yıllık'},
              {value: 3, text: 'Aylık'},
              {value: 2, text: 'Haftalık'},
              {value: 1, text: 'Günlük'}
                  ]"
          style="width:100px;margin: 0 3px"
          label=""
          item-text="text"
          item-value="value"
          filled
          hide-details
          solo
          dense
          @change="handleChange"
      >

      </v-select>
      <v-select
          v-model="giroAnalysisCurrency"
          :items="[
              {value: 2, text: 'Döviz'},
              {value: 1, text: 'TRY'}
                  ]"
          style="width:100px;margin: 0 3px"
          label=""
          item-text="text"
          item-value="value"
          filled
          hide-details
          solo
          dense
          @change="handleChange"
      >

      </v-select>
      <ExcelExport class="mt-1" :button-title="'Excel'" :file-name-prop="setExcelFileName" :column-prop="excelColumns" :data-prop="excelData"></ExcelExport>
      <div v-if="giroAnalysisTimePeriodFilterValue === 5">
        <v-menu
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="formattedDate(giroAnalysisDateRangeStartFilterValue)"
                placeholder="Filtre Başlangıç Tarihi"
                class="m-1"
                readonly
                filled
                solo
                dense
                clearable
                @click:clear="giroAnalysisDateRangeStartFilterValue = null"
                hide-details
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="giroAnalysisDateRangeStartFilterValue"
              locale="tr"
              :max="giroAnalysisDateRangeEndFilterValue ? giroAnalysisDateRangeEndFilterValue : 'NaN-Nan-Nan'"
          ></v-date-picker>
        </v-menu>
        <v-menu
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="formattedDate(giroAnalysisDateRangeEndFilterValue)"
                placeholder="Filtre Bitiş Tarihi"
                readonly
                solo
                filled
                class="m-1"
                dense
                clearable
                @click:clear="giroAnalysisDateRangeEndFilterValue = null"
                hide-details
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="giroAnalysisDateRangeEndFilterValue"
              locale="tr"
              :min="giroAnalysisDateRangeStartFilterValue"
          ></v-date-picker>
        </v-menu>
        <div class="w-100 text-center">
          <v-btn
              x-small
              class="mx-auto"
              color="primary darken-2"
              @click="_fetchGiroAnalysisReport"
          >
            FİLTRELE
          </v-btn>
        </div>
      </div>

    </template>
  </DonutChart>
</template>

<script>

import DonutChart from "@/components/shared/apex-charts/DonutChart";
import {numberConverter} from "../../../../helpers";
import {mapState, mapActions} from "vuex";
import {formattedDate} from "@/momentHelper";
import ExcelExport from "@/components/shared/ExcelExport";

export default {
  name: "EnIyiSatis",
  components: {
    ExcelExport,
    DonutChart
  },
  props:{
    dashboardFilterCurrentCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterSalesPersonCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterReportDbNameProp: {
      type: String,
      default: null
    }
  },
  computed:{
    ...mapState("auth",["user"]),
    currencyLabels: {
      get() {
        return this.getCurrencyLabels;
      },
    },
    setExcelFileName(){
      return 'Ciro Analiz ' +
      (this.giroAnalysisStockCodeFilterValue ? ('Grup Kod ' + this.giroAnalysisStockCodeFilterValue) : null) + ' ' +
      (this.dashboardFilterCurrentCodeProp ?? '') + ' ' +
      (this.giroAnalysisDateRangeStartFilterValue ?? '') + ' ' +
      (this.giroAnalysisDateRangeEndFilterValue ?? '')
    }
  },
  mounted(){
    this._fetchGiroAnalysisReport()
  },
  data(){
    return {
      giroAnalysisDataChartOptions: {
        series: [],
        chartOptions: {
          noData: {
            text: "Aradığınız Kriterde En İyi Satış Verisi Bulunamamıştır",
            align: "center",
            verticalAlign: "middle",
          },
          labels: [],
          legend: {
            show: true,
            position: 'right',
            horizontalAlign: 'center',
            verticalAlign: 'middle',
            floating: false,
            fontSize: '12px',
            offsetX: 0
          },
          responsive: [{
            breakpoint: 1500,
            options: {
              chart: {
                height: 600
              },
              legend: {
                show: true,
                position: 'bottom',
              },
            }
          }],
          tooltip: {
            y:{
              formatter: function (val){
                return val
              }
            }

          }
        }
      },
      giroAnalysisData: null,
      giroAnalysisDataLoading: true,
      giroAnalysisStockCodeFilterValue: 1,
      giroAnalysisTimePeriodFilterValue: 4,
      giroAnalysisDateRangeStartFilterValue: null,
      giroAnalysisDateRangeEndFilterValue: null,
      giroAnalysisCurrency: 1,
      excelColumns: [],
      excelData: [],
    }
  },
  methods:{
    formattedDate,
    ...mapActions("dashboard", [
      "fetchGiroAnalysisReport"
    ]),
    numberConverter,
    _fetchGiroAnalysisReport(){
      this.giroAnalysisDataLoading = true;

      const requestData = {
        params: {
          userId: this.user.UserId,
        },
        body: {
          ...(!(this.dashboardFilterCurrentCodeProp === "" || this.dashboardFilterCurrentCodeProp == null)) && {currentCode: this.dashboardFilterCurrentCodeProp},
          ...(!(this.dashboardFilterSalesPersonCodeProp === "" || this.dashboardFilterSalesPersonCodeProp == null)) && {salesPersonCode: this.dashboardFilterSalesPersonCodeProp},
          ...(!(this.dashboardFilterReportDbNameProp === "" || this.dashboardFilterReportDbNameProp == null)) && {reportDbName: this.dashboardFilterReportDbNameProp},
          ...(!(this.giroAnalysisTimePeriodFilterValue === "" || this.giroAnalysisTimePeriodFilterValue == null)) && {DateType: this.giroAnalysisTimePeriodFilterValue},
          ...(!(this.giroAnalysisStockCodeFilterValue === "" || this.giroAnalysisStockCodeFilterValue == null)) && {CodeType: this.giroAnalysisStockCodeFilterValue}
        }
      };

      if (this.giroAnalysisTimePeriodFilterValue === 5) {
        requestData.body.startDate = this.giroAnalysisDateRangeStartFilterValue;
        requestData.body.endDate = this.giroAnalysisDateRangeEndFilterValue;
      }
      this.fetchGiroAnalysisReport(requestData).then((result) => {
        if(result && result.data.success)
        {
          this.giroAnalysisDataChartOptions.series = [];
          this.giroAnalysisDataChartOptions.chartOptions.labels = [];
          let resultArray = result.data.data;

          for (let i = 0; i < resultArray.length; i++) {
            if (this.giroAnalysisCurrency === 1) this.giroAnalysisDataChartOptions.series.push(resultArray[i].salesAmount)
            else this.giroAnalysisDataChartOptions.series.push(resultArray[i].currencySalesAmount)

            const keys = Object.keys(resultArray[0]);
            this.prepareExcelData(keys, resultArray)

            this.giroAnalysisDataChartOptions.chartOptions.labels.push(resultArray[i].groupName)
          }
          this.giroAnalysisDataChartOptions.chartOptions.tooltip.y.formatter = (val) => {
            return this.numberConverter(val, this.giroAnalysisCurrency === 1 ? "TRY" : this.currencyLabels );
          }
        }
        else {
          this.giroAnalysisDataChartOptions.series = [];
          this.giroAnalysisDataChartOptions.chartOptions.labels = [];
        }
        this.giroAnalysisDataLoading = false;
      }).catch(error => {
        error
        this.giroAnalysisDataChartOptions.series = [];
        this.giroAnalysisDataChartOptions.chartOptions.labels = [];
        this.giroAnalysisDataLoading = false;
      })
    },
    handleChange(value) {
      if (value !== 5) {
        this._fetchGiroAnalysisReport();
      }
    },
    prepareExcelData(keys,data) {
      const labels = {
        groupName: "Grup Adı",
        salesAmount: "Satış Tutarı",
        currencySalesAmount: "Döviz Satış Tutarı",
        salesQuantity: "Satış Miktarı"
      };
      this.excelColumns = keys.map(key => ({
        label: labels[key],
        key: key
      }));
      this.excelData = data;
    }
  },
  watch: {
    dashboardFilterCurrentCodeProp(newVal){
      newVal;
      this._fetchGiroAnalysisReport()
    },
    dashboardFilterSalesPersonCodeProp(newVal){
      newVal;
      this._fetchGiroAnalysisReport()
    },
    dashboardFilterReportDbNameProp(newVal){
      newVal;
      this._fetchGiroAnalysisReport()
    },
    giroAnalysisCurrency(newVal){
      newVal;
      this._fetchGiroAnalysisReport()
    },
    // giroAnalysisTimePeriodFilterValue(newVal){
    //   if (newVal !== 5) {
    //   this._fetchGiroAnalysisReport();
    //   }
    // }
  }
}
</script>

<style scoped>

</style>